import { HTTP_METHODS } from '@studio/constants/axios';
import { TELEMETRY_API_V1 } from '@studio/constants/env-variables';
import type { Analytics } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    query: {} as Partial<Analytics.Derived.Telemetry.ContentLibraryQuery>,
    response: [] as Analytics.Get.LatLong[],
    url: `${TELEMETRY_API_V1}/customers/@customerId/contentLibrary/statistics/viewers/locations`,
  },
};
